import { getIn } from 'icepick';

export const LOAD_SESSION_WEBCASTS_DATA = 'event-guestside-site/sessionWebcast/LOAD_SESSION_WEBCASTS_DATA';


export function loadWebcastData() {
  return async (dispatch, getState) => {
    const state = getState();

    const { clients: { universalWebcastClient } } = state;
    const webcastsContainer = await universalWebcastClient.getWebcastsList(state.event.id);
    await dispatch({
      type: LOAD_SESSION_WEBCASTS_DATA,
      payload: { webcastsContainer }
    });
  };
}
/**
 * Update state with session webcast data.
 * @param state
 * @param action
 */
export function sessionsWebcastReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_SESSION_WEBCASTS_DATA: {
      let sessionWebcastsData = {};
      action.payload.webcastsContainer.data
        .filter(object => object.session)
        .forEach(sessionWebcastData => {
          const sessionId = sessionWebcastData.session.id;
          const joiningURL = getIn(sessionWebcastData, ['_links', 'join', 'href']);
          const joiningPassword = getIn(sessionWebcastData, ['_links', 'join', 'code']);
          const recordingURL = getIn(sessionWebcastData, ['_links', 'recording', 'href']);
          const recordingPassword = getIn(sessionWebcastData, ['_links', 'recording', 'code']);
          sessionWebcastsData[sessionId] = {
            joiningURL,
            joiningPassword,
            recordingURL,
            recordingPassword
          };
        });
      return sessionWebcastsData;
    }

    default:
      return state;
  }
}
